import React from 'react'
import { useSelector } from "react-redux";
import CheckMarketOpenClose from "../MarketOpenClose/Check-Market-Open";
import { CheckStoreWebOpen } from "./StoreCheck";
import { useMemo } from "react";
// import { setStoreCloseModal } from '../../redux/features/store';

import useStoreStatus from '../../hooks/useStoreStatus';
export default function storeStatus() {
    // const status = useRef(false)
    const { marketData, isStoreWebOpen } = useStoreStatus()
    const storeDeliveryPickupType = useSelector((state: any) => state.store.storeDeliveryPickupType);
    const selectedStore = useSelector((state: any) => state?.store?.selectedStore)


    const returnIsStoreClose = useMemo(() => {
        return isStoreWebOpen || Object.keys(marketData)?.length == 0 || storeDeliveryPickupType?.isPickupNDelivery == false;
    }, [marketData, isStoreWebOpen, storeDeliveryPickupType, selectedStore])


    return returnIsStoreClose
}
